export default "__VITE_ASSET__949371d7__"